module.exports = __webpack_public_path__ + "img/black-frame-middle-shadowed.4d6407b1.png";